import { BulkHistoryRecord } from "../types/CustomRecords";

export function useBuildBulkSummary(records: BulkHistoryRecord[]) {
  return {
    totalOperations: records.length,
    totalSuccess: records.reduce(
      (acc, r) => acc + r.custom_object_fields.success_count,
      0
    ),
    totalFailed: records.reduce(
      (acc, r) => acc + r.custom_object_fields.failed_count,
      0
    ),
    tickets: records
      .filter(r => r.custom_object_fields.action_type === "ticket")
      .reduce((acc, r) => acc + r.custom_object_fields.success_count, 0),
    users: records
      .filter(r => r.custom_object_fields.action_type === "user")
      .reduce((acc, r) => acc + r.custom_object_fields.success_count, 0),
    organizations: records
      .filter(r => r.custom_object_fields.action_type === "organization")
      .reduce((acc, r) => acc + r.custom_object_fields.success_count, 0),
  };
}
